import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import styled from 'styled-components';
// import {useTranslation} from 'react-i18next';
import { sendAnalyticsEvents } from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import useDebounce from '../../helper/useDebounce';
import { selectEventsData, setEventData } from '../events/eventsSlice';
import { selectShowPaymentError, setFormValidity } from './checkoutSlice';
import { setError } from '../error/errorSlice';
import CardForm from "./CardForm";
import { selectShowCheckout } from '../plans/plansSlice';

const Stripe = ({card, cvc, expiration, cardholder, renderBrand}) => {
    // const {t} = useTranslation();
    const [cardBrand, setCardBrand] = useState('');
    const [isCvv, setIsCvv] = useState(null);
    const [isExp, setIsExp] = useState(null);
    const [isCard, setIsCard] = useState(null);
    const [err, setErr] = useState('');
    const [isValid, setIsValid] = useState(false);
    const dispatch = useDispatch();
    const debouncedErr = useDebounce(err, 500);
    const debouncedValidity = useDebounce(isValid, 500);
    const eventsData = useSelector(selectEventsData);
    const showCheckout = useSelector(selectShowCheckout)
    const showError = useSelector(selectShowPaymentError)
    card.on('ready', () => {
        document.querySelectorAll('.__PrivateStripeElement-input').forEach(el => {
            el.setAttribute('inputmode', 'numeric');
        });
    });

    useEffect(() => {
        if (showCheckout || !showError) {
            card.focus()
        }
    },[showCheckout, showError, card])

    card.on('change', event => {
        if (event.brand && (event.brand !== 'unknown') && (event.brand !== cardBrand)) {
            setCardBrand(event.brand);
        }
        if (event.empty) {
            setCardBrand('')
        }
        event.complete && expiration.focus();
        fieldEventHandler(event, setIsCard);
    });

    expiration.on('change', event => {
        event.complete && cvc.focus();
        fieldEventHandler(event, setIsExp);
    });

    cvc.on('change', event => {
        event.complete && cardholder.current?.focus();
        fieldEventHandler(event, setIsCvv);
    });

    useEffect(() => {
        card.mount('#card-number-element');
        expiration.mount('#card-expiry-element');
        cvc.mount('#card-cvc-element');
    }, [card, cvc, expiration]);

    useEffect(() => {
        if (cardBrand && eventsData && (eventsData['cardBrand'] !== cardBrand)) {
            dispatch(setEventData({id: 'cardBrand', data: cardBrand}));
            sendAnalyticsEvents(EVENTS.cardMethodChosen, {...eventsData, 'cardBrand': cardBrand}); //Analytics event for starting typing the card number
        }
    }, [cardBrand, eventsData, dispatch]);

    const fieldEventHandler = (evt, setValidity) => {
        if (evt.error) {
            setErr(evt.error.message);
        }
        setValidity(evt.complete);
    };

    useEffect(() => {
        if (isCard && isCvv && isExp) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [isCard, isCvv, isExp, dispatch]);

    useEffect(() => {
        if (debouncedErr) {
            dispatch(setError({show: true, type: 'cardValidation', text: debouncedErr}));
        }
    }, [debouncedErr, dispatch]);

    useEffect(() => {
        dispatch(setFormValidity(debouncedValidity));
    }, [debouncedValidity, dispatch]);

  return (
    <CardForm
      method={'stripe'}
      card={card}
      expiration={expiration}
      cvc={cvc}
      cardholder={cardholder}
      cardBrand={cardBrand}
      renderBrand={renderBrand}
    />
  );
};


export default Stripe;
